module.exports = __webpack_public_path__ + "img/maximize_focused_pressed.381b8794.png";